export default {
  admin_roles: [],
  pagination: {},
  admin_role: {}
}
